export default "__VITE_ASSET__DBsYAtBQ__"